<template>
  <div class="user-login-div">
    <div class="user-login-header">
      <img src="@/assets/images/login/u69.png" />
      <div>{{ $t("userLogin.title") }}</div>
    </div>
    <div v-if="isLogin" class="user-login-card">
      <div>
        <el-avatar v-if="headImagePath" :size="40" :src="headImagePath" @error="true">
          <img style="width: 100%; height: 100%" :src="require('@/assets/images/head_img.png')" />
        </el-avatar>
        <el-avatar v-else :size="40" :src="require('@/assets/images/head_img.png')" />
      </div>
      <div
        v-if="loginUserName"
        class="overflow-hidden"
        style="margin-left: 20px; max-width: 130px"
        :title="loginUserName"
      >
        {{ loginUserName }}
      </div>
      <el-button style="margin-left: 10px" type="text" @click="handleLoginOut">{{
        $t("common.logoutAccount")
      }}</el-button>
    </div>
    <div v-else class="user-login-card" @click="showLoginModal()">
      <div>
        <span>{{ $t("userLogin.pleaseLogin") }}</span>
      </div>
    </div>
    <!--     登录-->
    <Login
      :active-name="activeName"
      :show-modal="showModal"
      @closeLogin="closeLogin"
      @changeActiveName="changeActiveNameEnterprise"
    ></Login>
  </div>
</template>

<script>
import Login from "./Login";
export default {
  name: "UserLogin",
  components: { Login },
  data() {
    return {
      activeName: "", // 登录tabs栏的切换状态
      showModal: false,
    };
  },
  computed: {
    loginUserName() {
      return this.$store.state.user.truename;
    },
    headImagePath() {
      return this.$store.state.user.headImagePath;
    },
    isLogin() {
      return this.$store.state.user.userId != null;
    },
  },
  methods: {
    // 退出登录
    handleLoginOut() {
      this.$store.dispatch("user/logout");
    },
    /**
     * 登陆
     */
    showLoginModal() {
      window.location.href = process.env.VUE_APP_D123_URL + "/?op=dxxLogin";
    },
    // 改变登录tab栏的状态 -- 企业
    changeActiveNameEnterprise() {
      this.activeName = "second";
    },
    // 登录弹出框的x符号
    closeLogin() {
      this.showModal = false;
      this.$store.dispatch("login/closeLoginDialog");
    },
  },
};
</script>

<style scoped lang="scss">
.overflow-hidden {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.user-login-div {
  height: calc(100% - 2px);
  padding: 0 30px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .user-login-header {
    display: flex;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      margin-right: 15px;
    }
  }
  .user-login-card {
    cursor: pointer;
    display: flex;
    align-items: center;
  }
}
</style>
